<template>
  <v-container fluid>
    <breadcrumbs />
    <v-row>
      <v-col cols="12" md="9">
        <h1>{{ title }}</h1>
      </v-col>
      <v-col cols="12" md="9">
        <filial-badge :name="filial && filial.name" />
      </v-col>
    </v-row>

    <v-form @submit.prevent="save(false)">
      <v-row>
        <v-col cols="12" md="9">
          <v-card>
            <loader v-if="loading" />
            <v-card-text v-else>
              <slot name="settings-form">
                <filial-settings-form
                  v-model="settings"
                  :keys="keys"
                  :category="category"
                  :hide-group-titles="hideGroupTitles"
                  :disabled="saving"
                >
                  <template #field="slotProps">
                    <slot name="field" v-bind="slotProps" />
                  </template>
                </filial-settings-form>
              </slot>
              <v-row>
                <v-col cols="4">
                  <v-btn
                    class="mb-2"
                    block
                    large
                    color="primary"
                    :loading="saving"
                    :disabled="loading"
                    @click.prevent="save(true)"
                  >
                    Сохранить
                  </v-btn>
                </v-col>
                <v-col cols="4">
                  <v-btn
                    class="mb-2"
                    block
                    large
                    color="success"
                    :loading="saving"
                    :disabled="loading"
                    @click.prevent="save(false)"
                  >
                    Применить
                  </v-btn>
                </v-col>
                <v-col cols="4">
                  <v-btn
                    block
                    large
                    color="error"
                    :loading="saving"
                    :disabled="loading"
                    @click.prevent="goToSettings"
                  >
                    Отменить
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Loader from '@/components/loader/Loader.vue'
  import FilialSettingsForm from '@/components/ui/crud/fields/filials/FilialSettingsForm.vue'
  import FilialBadge from '@/components/ui/FilialBadge.vue'
  import snackbarMessage from '@/mixins/snackbar-message'
  import RouteName from '@/models/enums/RouteName'
  import filialApi from '@/api/filials'

  export default {
    name: 'FilialSettingsView',
    components: { Loader, FilialSettingsForm, FilialBadge },
    mixins: [snackbarMessage],
    props: {
      title: { type: String, required: true },
      keys: { type: Array, default: null },
      category: { type: String, default: null },
      hideGroupTitles: { type: Boolean, default: false },
    },
    data () {
      return {
        settings: [],
        loading: false,
        saving: false,
      }
    },
    computed: {
      ...mapGetters({
        filialId: 'branches/getGlobalFilialId',
        filial: 'branches/getGlobalFilial',
      }),
    },
    created () {
      this.load()
    },
    methods: {
      async load () {
        if (!this.filialId) {
          this.showErrorMessage('Не выбран филиал')
          return
        }

        this.loading = true
        try {
          const res = await this.$store.dispatch('branches/fetchSingleBranch', this.filialId)
          this.settings = (res.data.data.settings || []).slice()
        } catch (e) {
          this.showErrorFromResponse(e)
        }
        this.loading = false
      },
      async save (redirect) {
        this.saving = true
        try {
          const filterFn = this.category
            ? (s) => s.group === this.category
            : (s) => (this.keys || []).includes(s.key)

          const items = this.settings
            .filter(filterFn)
            .map((s) => ({
              settingId: s.settingId,
              value: s.value,
              isDefaultValue: s.isDefaultValue,
            }))

          await filialApi.updateSettings(this.filialId, items)
          this.showSuccessMessage('Настройки сохранены')
          // App.vue пересобирает звуки заказов от globalFilial — без этого новый выбор только после перезагрузки
          this.$store.dispatch('appSettings/loadGlobalFilialInfo')

          if (redirect) this.goToSettings()
        } catch (e) {
          this.showErrorFromResponse(e)
        }
        this.saving = false
      },
      goToSettings () {
        this.$router.push({ name: RouteName.Settings })
      },
    },
  }
</script>
